/* eslint-disable no-unused-vars */
import React from 'react';

import TopicContainer from '../../components/TopicContainer';
import TopicItem from '../../components/TopicItem';
import './index.less';
import './index.en.less';
import Section0 from './section0';
import Section1 from './section1';
import Section2 from './section2';

interface ITopic900Props {
  settings: any;
}

const topic1100am: React.FunctionComponent<ITopic900Props> = ({ settings }) => (
  <TopicContainer className="financialAnalysisReporting">
    <TopicItem id="1">
      <Section0 settings={settings} />
    </TopicItem>
    <TopicItem className="topic-item financialAnalysisReporting_1" id="2">
      <Section1 settings={settings} />
    </TopicItem>
    <TopicItem className="topic-item financialAnalysisReporting_2" id="3">
      <Section2 settings={settings} />
    </TopicItem>
  </TopicContainer>
);

export default topic1100am;
